import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { CoreModule } from "./core/core.module";
import { MemberModule } from "./member/member.module";
import { AdminUsersModule } from "./admin-users/admin-users.module";
import { PromoCodeModule } from "./promo-code/promo-code.module";
import { DashboardModule } from "./dashboard/dashboard.module";
import { ReportsModule } from "./reports/reports.module";
import { AuthModule } from "./auth/auth.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppComponent } from "./app.component";
import { routing } from "./app.routing";
import { FormsModule } from "@angular/forms";
import { SubscriptionPlansModule } from "./subscription-plans/subscription-plans.module";
import { CouponsModule } from "./coupons/coupons.module";
import { ReferralsModule } from "./referrals/referrals.module";
import { NewAdminRedirectModule } from "./new-admin-redirect/new-admin-redirect.module";

@NgModule({
  declarations: [AppComponent],
  imports: [
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    MemberModule,
    AdminUsersModule,
    PromoCodeModule,
    DashboardModule,
    ReportsModule,
    AuthModule,
    routing,
    SubscriptionPlansModule,
    CouponsModule,
    ReferralsModule,
    NewAdminRedirectModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/app.module.ts